export default function dedupeContributors(contributors) {
	if (!Array.isArray(contributors)) {
		return contributors;
	}

	return contributors.filter((contributor, index) => {
		const firstOccurrenceIndex = contributors.findIndex(
			(c) =>
				c.role === contributor.role &&
				c.firstName === contributor.firstName &&
				c.lastName === contributor.lastName,
		);

		return firstOccurrenceIndex === index;
	});
}
